import { Routes } from '@angular/router';
import { AuthGuard } from '@guards/auth.guard';

export const AppRoutes: Routes = [
	{
		path: '',
		children: [
			{ path: '', redirectTo: 'public', pathMatch: 'full' },
			{ path: 'public', loadChildren: () => import('./public/public-routing.routes').then((m) => m.PublicRoutes) },
			{ path: 'auth', loadChildren: () => import('./auth/auth-routing.routes').then((m) => m.AuthRoutes), canActivate: [AuthGuard] },
			{ path: 'error', loadChildren: () => import('./error/error-routing.routes').then((m) => m.ErrorRoutes) },
			{ path: 'incident', loadChildren: () => import('./incident-flows/incident-flows.routes').then((m) => m.routes) },
			{ path: '**', redirectTo: '/error/404', pathMatch: 'full' },
		],
	},
];
